import { createRouter, createWebHistory } from "vue-router";
import { nextTick } from "vue";
import crm_router from "./CRM.js";
import frontend_router from "./Frontend.js";
import { installAlternates } from "../seo/alternates.js";

const routes = [...frontend_router, ...crm_router];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve) => {
        nextTick(() => {
          if (savedPosition) {
            resolve(savedPosition);
          } else if (to.hash) {
            resolve({ el: to.hash, behavior: "smooth", top: 65 });
          } else if (to.name === "collection" && to.params.collection_id) {
            resolve({ el: "#shop-filter", behavior: "smooth", top: 0 });
          } else if (to.name === "product" && to.params.product_id) {
            resolve({ el: "#product-details", top: 80 });
          } else {
            resolve({ top: 0, left: 0 });
          }
        });
    });
  },
});

installAlternates(router);

export default router;
